import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

export const listingsPanelTelemetry = createTelemetryObject({
  actions: {
    seeAvailabilityClicked: ({ joyPlaceId, hotelName, name = 'seeAvailabilityClicked' }: { joyPlaceId?: string; hotelName?: string; name?: string }) => ({
      category: 'accommodations',
      action: 'TravelButtonInteracted',
      extraInfo: {
        name,
        joyPlaceId,
        from: 'Accommodations Console',
        hotelName,
      },
    }),
    pickedByCoupleToggled: ({ state }: { state: boolean }) => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'pickedByCoupleToggled',
        state,
        from: 'Accommodations Console',
      },
    }),
    joyTravelBenefitsFilterChanged: ({ action }: { action: 'added' | 'removed' }) => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'joyTravelBenefitsFilterChanged',
        action,
        from: 'Accommodations Console',
      },
    }),
    showAvailableOnlyFilterChanged: ({ action }: { action: 'added' | 'removed' }) => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'showAvailableOnlyFilterChanged',
        action,
        from: 'Accommodations Console',
      },
    }),
    guestRatingFilterChanged: ({ rating, action }: { rating: number; action: 'added' | 'removed' }) => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'guestRatingFilterChanged',
        rating,
        action,
        from: 'Accommodations Console',
      },
    }),
    starRatingFilterChanged: ({ rating, action }: { rating: number; action: 'added' | 'removed' }) => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'starRatingFilterChanged',
        rating,
        action,
        from: 'Accommodations Console',
      },
    }),
    facilityFilterChanged: ({ facility, action }: { facility: string; action: 'added' | 'removed' }) => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'facilityFilterChanged',
        facility,
        action,
        from: 'Accommodations Console',
      },
    }),
    priceRangeFilterChanged: ({ minPrice, maxPrice }: { minPrice: number; maxPrice: number }) => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'priceRangeFilterChanged',
        minPrice,
        maxPrice,
        from: 'Accommodations Console',
      },
    }),
    allFiltersReset: () => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'allFiltersReset',
        from: 'Accommodations Console',
      },
    }),
  },
});

const { TelemetryProvider, useTelemetry } = createTelemetry(listingsPanelTelemetry, { eventId: '', section: '' });

export { TelemetryProvider, useTelemetry as useListingsPanelTelemetry };
